import {MonolithLocationFields} from "@services/graphql/queries/location";
import {useTranslation} from "@i18n/client";
import {useMemo} from "react";

import {I18nNamespace} from "@i18n";
import {s3ImageSource} from "../../../../../useS3ImgSrc";
import {useOpenTime} from "../../../../../utils/timeUtils";
import {getAddress} from "../../../../_common/Carbon";

export const useDataForImageRow = (location: MonolithLocationFields, specialtyId: string) => {
  const {t} = useTranslation(I18nNamespace.DB);

  const {name, address, coverImageId} = location;
  const description = useMemo(() => getAddress(address) || "", [address]);
  const src = useMemo(() => s3ImageSource(coverImageId || "", 1), [coverImageId]);
  const {isOpenNow, timeString} = useOpenTime(location, specialtyId);
  const emphasis = `${isOpenNow ? t("Open", {ns: "website-db"}) : ""} ${timeString}`;

  return {name, description, src, emphasis};
};
